import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { FontSizes } from '../../../../core/config/mainTheme';
import { TreeItem } from '../Tree.types';
import { renderCollapseIcon } from '../Tree.utils';
import TreeButton from '../TreeButton';

interface Props {
  item: TreeItem;
  isExpanded: boolean;
  onExpand: () => void;
}

const TreeCollapseButton: React.FC<Props> = React.memo(({ item, onExpand, isExpanded }) => {
  const classes = useStyles();

  if (item.isLeaf) {
    return <span className={classes.collapse}></span>;
  }

  return (
    <TreeButton className={classNames([classes.collapse, classes.collapseBtn])} onClick={onExpand}>
      {renderCollapseIcon(isExpanded)}
    </TreeButton>
  );
});

const useStyles = makeStyles((theme) => ({
  collapse: {
    width: '24px',
    padding: 0,
    border: 0,
    background: 'none',
    lineHeight: 'normal',
    color: 'inherit',
    fontSize: FontSizes.size.small,
  },
  collapseBtn: {
    cursor: 'pointer',
  },
  checkbox: {
    width: '30px',
    height: '28px',
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
}));

export default TreeCollapseButton;
